import React, { useState, useEffect } from "react";
import logo from "./../../src/assets/locoachelear2.png";
import sloganOrange from "./../../src/assets/sloganapporange.png";
import playStore from "./../../src/assets/playstore.png";
import applestore from "./../../src/assets/applestore.png";
import FacebookIcon from "@mui/icons-material/Facebook";
import "./Home.css";

function Home({ props }: any) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <div className="home">
      {/* NAVBAR */}
      <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
        <div className="navbar__container">
          <div className="navbar__brand" onClick={() => scrollTo("hero")}>
            <img src={logo} alt="A Chelear" className="navbar__logo" />
            <span className="navbar__name">A Chelear</span>
          </div>
          <button
            className={`navbar__burger ${menuOpen ? "navbar__burger--open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menú"
          >
            <span />
            <span />
            <span />
          </button>
          <ul className={`navbar__links ${menuOpen ? "navbar__links--open" : ""}`}>
            <li onClick={() => scrollTo("features")}>¿Qué es?</li>
            <li onClick={() => scrollTo("how")}>¿Cómo funciona?</li>
            <li onClick={() => scrollTo("download")}>Descarga</li>
            <li>
              <a
                href="https://www.facebook.com/profile.php?id=61559163846604"
                target="_blank"
                rel="noopener noreferrer"
                className="navbar__fb"
              >
                <FacebookIcon fontSize="small" />
              </a>
            </li>
          </ul>
        </div>
      </nav>

      {/* HERO */}
      <section className="hero" id="hero">
        <div className="hero__bg-circles">
          <span className="circle circle--1" />
          <span className="circle circle--2" />
          <span className="circle circle--3" />
        </div>
        <div className="hero__content">
          <div className="hero__text">
            <span className="hero__badge">🍺 Tu guía cervecera</span>
            <h1 className="hero__title">
              Encuentra el lugar<br />
              <span className="hero__highlight">perfecto para chelear</span>
            </h1>
            <p className="hero__desc">
              Bares, expendios y restaurantes cerca de ti. En segundos,
              sin complicaciones, con todo lo que necesitas saber.
            </p>
            <div className="hero__ctas">
              <a
                href="https://play.google.com/store/apps/details?id=com.expendiosexpress&pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn--primary"
              >
                <img src={playStore} alt="Play Store" className="btn__icon" />
                Google Play
              </a>
              <a
                href="https://apps.apple.com/app/id6775327333"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn--primary"
              >
                <img src={applestore} alt="App Store" className="btn__icon" />
                App Store
              </a>
            </div>
          </div>
          <div className="hero__visual">
            <div className="hero__phone-mockup">
              <img src={logo} alt="A Chelear app" className="hero__mascot" />
            </div>
            <img src={sloganOrange} alt="A Chelear" className="hero__slogan" />
          </div>
        </div>
        <div className="hero__wave">
          <svg viewBox="0 0 1440 100" preserveAspectRatio="none">
            <path
              d="M0,60 C360,100 1080,0 1440,60 L1440,100 L0,100 Z"
              fill="#f8f9fc"
            />
          </svg>
        </div>
      </section>

      {/* FEATURES */}
      <section className="features" id="features">
        <div className="section-container">
          <span className="section-label">¿Qué es A Chelear?</span>
          <h2 className="section-title">
            Todo lo que necesitas para tu próxima chela
          </h2>
          <div className="features__grid">
            <div className="feature-card">
              <div className="feature-card__icon">📍</div>
              <h3>Cerca de ti</h3>
              <p>
                Usa tu ubicación para encontrar bares, expendios y restaurantes
                a tu alrededor en tiempo real.
              </p>
            </div>
            <div className="feature-card feature-card--highlighted">
              <div className="feature-card__icon">🍺</div>
              <h3>Todo en un lugar</h3>
              <p>
                Directorio completo de lugares para tomar o comer. Filtra por
                tipo de establecimiento y distancia.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-card__icon">⚡</div>
              <h3>Rápido y sencillo</h3>
              <p>
                Interfaz pensada para que en segundos ya sepas a dónde ir.
                Sin registro, sin complicaciones.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="how" id="how">
        <div className="section-container">
          <span className="section-label">Simple como debe ser</span>
          <h2 className="section-title">¿Cómo funciona?</h2>
          <div className="how__steps">
            <div className="step">
              <div className="step__number">1</div>
              <div className="step__content">
                <h3>Descarga la app</h3>
                <p>Disponible en Google Play y App Store.</p>
              </div>
            </div>
            <div className="step__connector" />
            <div className="step">
              <div className="step__number">2</div>
              <div className="step__content">
                <h3>Activa tu ubicación</h3>
                <p>La app detecta automáticamente los lugares cercanos a ti.</p>
              </div>
            </div>
            <div className="step__connector" />
            <div className="step">
              <div className="step__number">3</div>
              <div className="step__content">
                <h3>¡A chelear!</h3>
                <p>Elige tu lugar favorito y disfruta la experiencia.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* DOWNLOAD CTA */}
      <section className="download" id="download">
        <div className="download__container">
          <div className="download__text">
            <h2>¿Listo para chelear?</h2>
            <p>
              Descarga A Chelear gratis y descubre todos los lugares cerca de ti.
            </p>
            <div className="download__btns">
              <a
                href="https://play.google.com/store/apps/details?id=com.expendiosexpress&pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn--orange"
              >
                <img src={playStore} alt="Play Store" className="btn__icon" />
                Descargar en Google Play
              </a>
              <a
                href="https://apps.apple.com/app/id6775327333"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn--orange"
              >
                <img src={applestore} alt="App Store" className="btn__icon" />
                Descargar en App Store
              </a>
            </div>
          </div>
          <div className="download__image">
            <img src={logo} alt="A Chelear mascot" />
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer__container">
          <div className="footer__brand">
            <img src={logo} alt="A Chelear" className="footer__logo" />
            <p>Tu directorio de bares y cervecerías</p>
          </div>
          <div className="footer__links">
            <a
              href="https://achelear.com.mx/avisoPrivacidad"
              target="_blank"
              rel="noopener noreferrer"
            >
              Aviso de privacidad
            </a>
            <a href="/soporte">
              Soporte
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61559163846604"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon fontSize="small" style={{ marginRight: 4 }} />
              Facebook
            </a>
          </div>
          <p className="footer__copy">
            © {new Date().getFullYear()} A Chelear. Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Home;
